import platform from 'platform'

// Environment 2
const testUrl = window.location.href
let environmentConfig = null

for(const _environment of window.environments)
{
    if(testUrl.match(_environment.test))
    {
        environmentConfig = _environment.config
    }
}

if(environmentConfig === null)
{
    console.warn('No matching environment')
}

const config = environmentConfig

// Tracking
config.analyticsId = 'UA-118705249-1'

// Platform
config.platform = {}
config.platform.product = platform.product
config.platform.os = platform.os.family
config.platform.mobile = ['Android', 'iOS', 'Windows Phone'].indexOf(platform.os.family) !== - 1
config.platform.browser = {}
config.platform.browser.name = platform.name.toLowerCase()
config.platform.browser.version = platform.version

document.documentElement.classList.add(`browser-${config.platform.browser.name.replace(' ', '-')}`)
document.documentElement.classList.add(`version-${parseInt(config.platform.browser.version)}`)

// Scroll
config.scrollType = config.platform.browser.name === 'ie' ? 'body' : 'windows'
config.scrollHeightElement = config.scrollType === 'body' ? document.querySelector('#app') : document.body

// Langs
config.langs = {
    all: ['en', 'fr'],
    default:
    {
        name: 'home',
        params:
        {
            lang: 'en'
        }
    }
}

// Title
config.title = 'Orano'

console.log(config)

// Export
export default config



// WEBPACK FOOTER //
// ./src/config.js